import * as actionTypes from './actionTypes';



export const toggleSidebar = (data) =>{
    return {
        type: actionTypes.TOGGLE_SIDEBAR,
        data: data
    }
}